import Carrier from '@/models/carrier'

export default {
  namespaced: true,
  state: {
    schema: Carrier.schema()
  },
  actions: {
    async list ({ dispatch, state }) {
      return dispatch('list', { modelClass: Carrier }, { root: true })
        .then(response => { return response.results })
        .catch(error => { throw error })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/carrier.js